import { render, staticRenderFns } from "./UserSignup.vue?vue&type=template&id=adfe7b88"
import script from "./UserSignup.vue?vue&type=script&lang=ts"
export * from "./UserSignup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_prettier@1.19.1_react-dom@16.14.0_react@16.14.0_vue-templ_abmptsf5cmy4peksmiftadmdpm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports